import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const clientApiUrl = process.env.REACT_APP_CLIENT_API_URL;

const ReportAPI = {
	getAllReports: () => {
		return axios
			.get(`${apiUrl}/reports`)
			.then((response) => response.data as AssessmentReportListingDTO[]);
	},
	getReport: (request: GetReportRequest) => {
		return axios
			.get(`${apiUrl}/reports/${request.reportId}`)
			.then((response) => response.data as ReportNecessaryInfoDTO);
	},
	getReportSettings: (request: GetReportSettingsRequest) => {
		return axios
			.get(`${apiUrl}/reports/${request.reportId}/report-settings`)
			.then((response) => response.data as ReportSettingDTO);
	},
	clientSiteSaveReportV2Data: (
		request: ClientPostReportPDFRequest,
		files: File[]
	) => {
		const data = new FormData();

		files.forEach((file) => {
			data.append(file.name, file);
		});

		return axios
			.post(
				`${clientApiUrl}/datasets/${request.datasetId}/reports/${request.reportId}/report-pdf`,
				data
			)
			.then((response) => response.data as boolean);
	},
	saveReportV2Data: (request: PostReportPDFRequest, files: File[]) => {
		const data = new FormData();

		files.forEach((file) => {
			data.append(file.name, file);
		});

		return axios
			.post(
				`${apiUrl}/client/${request.clientId}/reports/${request.reportId}/report-pdf`,
				data
			)
			.then((response) => response.data as boolean);
	},
	getCoreTestForReport: (request: GetCoreTestResultForAdminReportRequest) => {
		return axios
			.get(
				`${apiUrl}/reports/${request.reportId}/coreTest/${request.coreTestResultId}`
			)
			.then((response) => response.data as CoreTestResultDTO);
	},
	getCareTestForReport: (request: GetCareTestResultForAdminReportRequest) => {
		return axios
			.get(
				`${apiUrl}/reports/${request.reportId}/careTest/${request.careTestResultId}`
			)
			.then((response) => response.data as CareTestResultDTO);
	},
	getVitalsTestForReport: (
		request: GetVitalsTestResultForAdminReportRequest
	) => {
		return axios
			.get(
				`${apiUrl}/reports/${request.reportId}/vitalsTest/${request.vitalsTestResultId}`
			)
			.then((response) => response.data as VitalsTestResultDTO);
	},
	getVitalsFactorsForReport: (
		request: GetVitalsFactorsForAdminReportRequest
	) => {
		return axios
			.get(
				`${apiUrl}/reports/${request.reportId}/vitalsTest/${request.vitalsTestResultId}/factors`
			)
			.then((response) => response.data as VitalsFactorsForReportDTO);
	},

	// clientsite
	clientSiteGenerateV2ReportPDF: (request: ClientGetV2ReportRequest) => {
		window.open(
			`${clientApiUrl}/datasets/${request.datasetId}/reports/${request.reportId}/V2ReportRequest`,
			"_blank"
		);
	},
	generateV2ReportPDF: (request: GetV2ReportRequest) => {
		window.open(
			`${apiUrl}/reports/${request.reportId}/V2ReportRequest`,
			"_blank"
		);
	},
	getClientSiteReport: (request: GetClientSiteReportRequest) => {
		return axios
			.get(
				`${clientApiUrl}/datasets/${request.datasetId}/reports/${request.reportId}`
			)
			.then((response) => response.data as ReportNecessaryInfoDTO);
	},
	getClientSiteReportSettings: (
		request: GetClientSiteReportSettingsRequest
	) => {
		return axios
			.get(
				`${clientApiUrl}/datasets/${request.datasetId}/reports/${request.reportId}/report-settings`
			)
			.then((response) => response.data as ReportSettingDTO);
	},
	clientSiteGetCoreTestForReport: (
		request: GetCoreTestResultForClientReportRequest
	) => {
		return axios
			.get(
				`${clientApiUrl}/datasets/${request.datasetId}/reports/${request.reportId}/coreTest/${request.coreTestResultId}`
			)
			.then((response) => response.data as CoreTestResultDTO);
	},
	clientSiteGetCareTestForReport: (
		request: GetCareTestResultForClientReportRequest
	) => {
		return axios
			.get(
				`${clientApiUrl}/datasets/${request.datasetId}/reports/${request.reportId}/careTest/${request.careTestResultId}`
			)
			.then((response) => response.data as CareTestResultDTO);
	},
	clientSiteGetVitalsTestForReport: (
		request: GetVitalsTestResultForClientReportRequest
	) => {
		return axios
			.get(
				`${clientApiUrl}/datasets/${request.datasetId}/reports/${request.reportId}/vitalsTest/${request.vitalsTestResultId}`
			)
			.then((response) => response.data as VitalsTestResultDTO);
	},
	clientSiteGetVitalsFactorsForReport: (
		request: GetVitalsFactorsForClientReportRequest
	) => {
		return axios
			.get(
				`${clientApiUrl}/datasets/${request.datasetId}/reports/${request.reportId}/vitalsTest/${request.vitalsTestResultId}/factors`
			)
			.then((response) => response.data as VitalsFactorsForReportDTO);
	},
};

export default ReportAPI;
